import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "down-arrow",
  "use": "down-arrow-usage",
  "viewBox": "0 0 90 90",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"currentColor\" viewBox=\"0 0 90 90\" id=\"down-arrow\">\n  <path fill-rule=\"evenodd\" d=\"M70.634 58.134a1.25 1.25 0 0 0-1.768-1.768L46 79.232V6.25a1.25 1.25 0 0 0-2.5 0v72.982L20.634 56.366a1.25 1.25 0 0 0-1.768 1.768L43.863 83.13a1.246 1.246 0 0 0 1.77.003l25-25Z\" clip-rule=\"evenodd\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol